import React, { useState } from "react";

/* ── Image imports ── */
import HeroBgImg  from "../../asset/images/news/hero-bg.webp";
import BcSepIcon from "../../asset/images/about/breadcrumb-separator.svg";
import NewsImg1   from "../../asset/images/news/news-1.webp";
import NewsImg2   from "../../asset/images/news/news-2.webp";
import NewsImg3   from "../../asset/images/news/news-3.webp";
import NewsImg4   from "../../asset/images/news/news-4.webp";
import NewsImg5   from "../../asset/images/news/news-5.webp";
import NewsImg6  from "../../asset/images/news/news-6.webp";
import NewsImg7   from "../../asset/images/news/news-7.webp";
import NewsImg8   from "../../asset/images/news/news-8.webp";
import NewsImg9   from "../../asset/images/news/news-9.webp";
import NewsImg10   from "../../asset/images/news/news-10.webp";
import NewsImg11   from "../../asset/images/news/news-11.webp";
import NewsImg12   from "../../asset/images/news/news-12.webp";
import NewsImg13   from "../../asset/images/news/news-13.webp";
import NewsImg14   from "../../asset/images/news/news-14.webp";
import NewsImg15   from "../../asset/images/news/news-15.webp";
import NewsImg16   from "../../asset/images/news/news-16.webp";
import NewsImg17   from "../../asset/images/news/news-17.webp";
import NewsImg18   from "../../asset/images/news/news-18.webp";
import NewsImg19   from "../../asset/images/news/news-19.webp";
import NewsImg20   from "../../asset/images/news/news-20.webp";
import NewsImg21   from "../../asset/images/news/news-21.webp";
import NewsImg22   from "../../asset/images/news/news-22.webp";
import NewsImg23   from "../../asset/images/news/news-23.webp";
import NewsImg24   from "../../asset/images/news/news-24.webp";
import NewsImg25   from "../../asset/images/news/news-25.webp";
import NewsImg26   from "../../asset/images/news/news-26.webp";
import NewsImg27   from "../../asset/images/news/news-27.webp";
import NewsImg28   from "../../asset/images/news/news-28.webp";
import NewsImg29   from "../../asset/images/news/news-29.webp";
import NewsImg30   from "../../asset/images/news/news-30.webp";
import NewsImg31   from "../../asset/images/news/news-31.webp";
import NewsImg32   from "../../asset/images/news/news-32.webp";
import NewsImg33   from "../../asset/images/news/news-33.webp";
import NewsImg34   from "../../asset/images/news/news-34.webp";
import NewsImg35   from "../../asset/images/news/news-35.webp";
import NewsImg36   from "../../asset/images/news/news-36.webp";
import NewsImg37   from "../../asset/images/news/news-37.webp";
import NewsImg38   from "../../asset/images/news/news-38.webp";
import NewsImg39   from "../../asset/images/news/news-39.webp";
import NewsImg40   from "../../asset/images/news/news-40.webp";
import NewsImg41   from "../../asset/images/news/news-41.webp";
import NewsImg42   from "../../asset/images/news/news-42.webp";
import NewsImg43   from "../../asset/images/news/news-43.webp";
import NewsImg44   from "../../asset/images/news/news-44.webp";

/* ── Icon imports ── */
import YoutubeIcon      from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon     from "../../asset/images/news/icon-linkedin.svg";
import ReadMoreArrow    from "../../asset/images/news/icon-read-more-arrow.svg";
import PrevArrowIcon    from "../../asset/images/news/icon-prev-arrow.svg";
import NextArrowIcon    from "../../asset/images/news/icon-next-arrow.svg";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .nw { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══════════════════════════════════════════
     1. HERO
  ══════════════════════════════════════════ */
  .nw-hero {
    position: relative;
    width: 100%;
    height: 460px;
    overflow: hidden;
   
  }

  .nw-hero-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }

  .nw-hero-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      to right,
      rgba(0,0,0,0.72) 0%,
      rgba(0,0,0,0.35) 60%,
      rgba(0,0,0,0.10) 100%
    );
  }

  .nw-hero-content {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 102px;
    max-width: 1600px;
    margin: 0 auto;
    left: 0; right: 0;
  }

  .nw-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px;
    font-weight: 600;
    color: #ffffff;
    line-height: 120%;
    margin-bottom: 15px;
  }

  .nw-hero-divider {
    width: 120px;
    height: 2px;
    background: #EB2019;
    border: none;
  }

  /* ══════════════════════════════════════════
     2. BREADCRUMB
  ══════════════════════════════════════════ */
  .nw-breadcrumb {
    width: 100%;
    padding: 40px 0 0 0;
  }

  .nw-breadcrumb-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .nw-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #202020;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 14px;
    transition: color 0.15s;
  }

  .nw-bc-item:hover { color: #EB2019; }

  .nw-bc-sep {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    
    margin: 0 8px;
    flex-shrink: 0;
  }

  .nw-bc-sep svg { display: block; }
  .nw-bc-item.active { color: #202020; font-weight: 500; }

  /* ══════════════════════════════════════════
     SHARED INNER
  ══════════════════════════════════════════ */
  .nw-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
  }

  /* ══════════════════════════════════════════
     3. MAIN CONTENT AREA
  ══════════════════════════════════════════ */
  .nw-main-section {
    padding: 80px 0 120px 0;
  }

  .nw-main-row {
    display: flex;
    align-items: flex-start;
    gap: 119px;
  }

  /* ── LEFT: News List ── */
  .nw-list {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  .nw-item {
    display: flex;
    align-items: flex-start;
    gap: 30px;
    padding: 10px;
    border: 1px solid #DEDEDE;
    border-radius:10px;
  }

  .nw-item-img {
    flex: 0 0 337px;
    height: 330px;
    object-fit: cover;
    border-radius: 6px;
    display: block;
  }

  .nw-item-body {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-top:30px;
  }

  .nw-item-title {
    font-family: 'Poppins', sans-serif;
    font-size: 18px;
    font-weight: 500;
    color: #202020;
    line-height: 140%;
    text-decoration: none;
    transition: color 0.15s;
  }

  .nw-item-title:hover { color: #EB2019; }

  .nw-item-meta {
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #EB2019;
    line-height: 120%;
  }

  .nw-item-excerpt {
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #777777;
    line-height: 160%;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .nw-read-more {
    display: inline-flex;
    align-items: center;
    gap: 14px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #EB2019;
    text-decoration: none;
    margin-top: 15px;
    transition: gap 0.15s;
  }

  .nw-read-more-arrow {
    display: inline-block;
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }

  /* ── RIGHT: Sidebar ── */
  .nw-sidebar {
    flex: 0 0 475px;
  }

  .nw-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 600;
    color: #202020;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #E8E8E8;
    line-height: 120%;
  }

  .nw-social-icons {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 5px;
  }

  .nw-social-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 6px;
    overflow: hidden;
    transition: opacity 0.15s;
  }

  .nw-social-icon:hover { opacity: 0.8; }

  .nw-social-icon img {
    width: 40px;
    height: 40px;
    object-fit: contain;
    display: block;
  }

  /* ══════════════════════════════════════════
     4. PAGINATION
  ══════════════════════════════════════════ */
  .nw-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 24px;
    margin-top: 60px;
    flex-wrap: wrap;
  }

  .nw-page-btn {
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #202020;
    background: none;
    border: none;
    cursor: pointer;
    padding: 9px 16px;
    border-radius: 20px !important;
    transition: background 0.15s, color 0.15s;
    display: flex;
    align-items: center;
    gap: 20px;
    text-decoration: none;
  }

  .nw-page-btn:hover {
    background: #FFF0EF;
    color: #EB2019;
  }

  .nw-page-btn.active {
    background: #EB2019;
    color: #ffffff;
    border-radius: 4px;
  }

  .nw-page-btn.prev-next {
    color: #202020;
    font-weight: 400;
  }

  .nw-page-nav-icon {
    display: inline-block;
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }

  .nw-page-dots {
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    color: #202020;
    padding: 8px 4px;
  }

  /* ══════════════════════════════════════════
     RESPONSIVE — TABLET (max-width: 768px)
  ══════════════════════════════════════════ */
  @media (max-width: 768px) {
    .nw-hero              { height: 350px; }
    .nw-hero-content      { padding: 0 32px; }
    .nw-hero-title        { font-size: 30px; }
    .nw-breadcrumb        { padding: 24px 0 0 0; }
    .nw-breadcrumb-inner  { padding: 0 32px; }
    .nw-inner             { padding: 0 32px; }
     .nw-item              { flex-direction: column; gap: 0px; }
    .nw-main-section      { padding: 48px 0 48px 0; }
    .nw-main-row          { flex-direction: column; gap: 48px; }
    .nw-sidebar           { flex: none; width: 100%; }
    .nw-item-img          { flex: 0 0 300px; height: 300px; }
    .nw-pagination {     margin-top: 24px;}
    .nw-read-more {     margin-top: 5px;}
  }

  /* ══════════════════════════════════════════
     RESPONSIVE — MOBILE (max-width: 480px)
  ══════════════════════════════════════════ */
  @media (max-width: 480px) {
    .nw-hero              { height: 300px; }
    .nw-hero-content      { padding: 0 16px; }
    .nw-hero-title        { font-size: 24px; margin-bottom: 12px; }
    .nw-breadcrumb        { padding: 30px 0 0 0; }
    .nw-breadcrumb-inner  { padding: 0 16px; gap: 14px; }
    .nw-bc-item           { font-size: 14px; gap: 8px; }
    .nw-bc-sep            { width: 18px; height: 18px; margin: 0 4px; }
    .nw-inner             { padding: 0 16px; }
    .nw-main-section      { padding: 30px 0 60px 0; }
    .nw-main-row          { flex-direction: column; gap: 30px; }
    .nw-sidebar           { flex: none; width: 100%; }
    .nw-item              { flex-direction: column; gap: 20px; padding:0px;border:none;}
    .nw-item-meta { font-family: 'DM Sans', sans-serif;}
    .nw-item-excerpt { font-family: 'DM Sans', sans-serif;}
    .nw-item-img          { flex: none; width: 100%; height: 250px; }
    .nw-item-body {      margin-top: 0px;}
    .nw-item-title        { font-size: 20px;line-height:140%; }
    .nw-pagination        { margin-top: 30px; gap: 4px; }
    .nw-page-btn          { padding: 6px 10px; font-size: 13px; }
  }
`;

const BcArrow = () => (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
    <path d="M2 1l3 3-3 3" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
const newsItems = [
  {
    img: NewsImg1,
    slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
    title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
    date: "July 17, 2025",
    comments: "No Comments",
    excerpt: "What keeps electric vehicles (EVs) on the road and large energy storage systems running smoothly? Do you have any information on this aspect? It's not",
  },
  {
    img: NewsImg2,
    slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
    title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
    date: "July 17, 2025",
    comments: "No Comments",
    excerpt: "How quickly industrial air pollution control is evolving these days? Evolution is significant, and sustainable solutions are on the rise. The planet is focusing on",
  },
  {
    img: NewsImg3,
    slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
    title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
    date: "July 17, 2025",
    comments: "No Comments",
    excerpt: "Have you heard the buzz around green hydrogen lately? It's not simply a movement — it's the fortune of clean power. But while the idea",
  },
  {
    img: NewsImg4,
    slug: "transformer-bushings-guide/",
    title: "Transformer Bushings: Types & Importance",
    date: "July 1, 2025",
    comments: "No Comments",
    excerpt: "In the vast and intricate world of electrical power systems, transformers are key players. They ensure electricity is transmitted and distributed efficiently by adjusting voltage",
  },
  {
    img: NewsImg5,
    slug: "electrostatic-precipitator-market-outlook-2025-2035-trends-and-forecasts/",
    title: "Electrostatic Precipitator Market Outlook 2025–2035: Trends and Forecasts",
    date: "July 1, 2025",
    comments: "No Comments",
    excerpt: "As industries strive for cleaner operations, electrostatic precipitators (ESPs) are emerging as pivotal performers in emission control. They are the unacknowledged entities battling industrial air",
  },
  {
    img: NewsImg6,
    slug: "top-5-mistakes-industries-make-when-buying-rectifiers-and-how-to-avoid-them/",
    title: "Top 5 Mistakes Industries Make When Buying Rectifiers — and How to Avoid Them",
    date: "June 17, 2025",
    comments: "No Comments",
    excerpt: "The rectifier is a crucial component in pollution control and high-voltage systems, such as electrostatic precipitators. Still, many industries make common mistakes in choosing the",
  },
  {
    img: NewsImg7,
    slug: "how-transformer-rectifier-sets-power-efficient-electrostatic-precipitators/",
    title: "How Transformer-Rectifier Sets Power Efficient-Electrostatic Precipitators",
    date: "June 17, 2025",
    comments: "No Comments",
    excerpt: "Industrial pollution control is a trending topic among factories that manage to keep their emissions in check. And the one doing the heavy lifting behind",
  },
  {
    img: NewsImg8,
    slug: "what-is-igbt-module",
    title: "What is IGBT Module?",
    date: "June 5, 2025",
    comments: "No Comments",
    excerpt: "An IGBT Module (Insulated Gate Bipolar Transistor Module) is a power electronic device used to switch and control large amounts of current and voltage. It",
  },
  {
    img: NewsImg9,
    slug: "powering-future-igbt-modules",
    title: "Powering the Future: Why IGBT Modules Are the Silent Heroes Behind Smart Energy",
    date: "May 27, 2025 ",
    comments: "No Comments",
    excerpt: "Powering the Future: Why IGBT Modules Are the Silent Heroes Behind Smart Energy In today’s world, everything is becoming smarter and more energy-efficient — from",
  },
  {
    img: NewsImg10,
    slug: "industrial-smps-solutions",
    title: "Industrial SMPS Solutions: Powering the Future of Industrial Automation and Pollution Control",
    date: "May 21, 2025 ",
    comments: "No Comments",
    excerpt: "Switch Mode Power Supplies (SMPS) have revolutionized how industries manage and distribute power. By converting electrical energy with high efficiency and minimal heat loss, SMPS",
  },
  {
    img: NewsImg11,
    slug: "why-upgrading-your-transformer-rectifier-system-makes-business-sense/",
    title: "Why Upgrading Your Transformer Rectifier System Makes Business Sense?",
    date: "May 16, 2025",
    comments: "No Comments",
    excerpt: "Upgrading ESP’s Transformer Rectifier system makes business sense. Does it? Before diving into it, let us understand what an ESP Transformer Rectifier System is. ESP",
  },
  {
    img: NewsImg12,
    slug: "understanding-switch-mode-power-supplies",
    title: "Understanding Switch Mode Power Supplies: How They Work and Why They Matter",
    date: "May 16, 2025",
    comments: "No Comments",
    excerpt: "Today’s electronic world is tech-driven, and electronic devices like TVs, mobiles, and laptops are becoming essential parts of our lives. These devices need efficient power",
  },
  {
    img: NewsImg13,
    slug: "medium-frequency-power-switching",
    title: "The Role of Medium-Frequency Power Switching in Modern Manufacturing",
    date: "May 16, 2025",
    comments: "No Comments",
    excerpt: "Industries today are becoming faster than ever, thanks to the revolutions in factories, power plants, and EV industries. Thus, the demand for faster, more innovative,",
  },
  {
    img: NewsImg14,
    slug: "igbt-modules-modern-electronics",
    title: "IGBT Modules: The Power Behind Modern Electronics",
    date: "May 3, 2025",
    comments: "No Comments",
    excerpt: "What Are IGBT Modules? An IGBT module is a type of power semiconductor device that efficiently manages high voltages and currents in power electronic systems.",
  },
  {
    img: NewsImg15,
    slug: "comprehensive-guide-igbt-power-module",
    title: "A Comprehensive Guide to IGBT Power Module",
    date: "April 28, 2025",
    comments: "No Comments",
    excerpt: "Insulated Gate Bipolar Transistor (IGBT) modules are vital components in modern power electronics. They combine the ease of control of MOSFETs with the high current",
  },
   {
    img: NewsImg16,
    slug: "understanding-electrostatic-precipitators",
    title: "Understanding Electrostatic Precipitators: A Comprehensive Guide",
    date: "April 28, 2025",
    comments: "No Comments",
    excerpt: "What Are Electrostatic Precipitators? Electrostatic precipitators are devices used to remove solid particles, such as dust and smoke, from gases in industrial processes. They work",
  },
  {
    img: NewsImg17,
    slug: "ultimate-guide-switch-mode-power-supply",
    title: "The Ultimate Guide to Switch Mode Power Supply: Powering the Future of Electronics",
    date: "April 28, 2025",
    comments: "No Comments",
    excerpt: "Efficient and reliable electronic power supply systems are critical to driving electronics performance. One such innovation that has become a cornerstone in modern electronics is",
  },
  {
    img: NewsImg18,
    slug: "transformer-rectifier-applications",
    title: "Transformer Rectifier: Applications, Design, and Industry Insights",
    date: "April 28, 2025",
    comments: "No Comments",
    excerpt: "What is a Transformer Rectifier? A transformer rectifier is a compact and efficient device that combines two key functions in one unit: voltage transformation and",
  },
  {
    img: NewsImg19,
    slug: "complete-guide-emission-control-systems",
    title: "A Complete Guide to Emission Control Systems: How They Work and Why They Matter",
    date: "April 28, 2025",
    comments: "No Comments",
    excerpt: "Controlling emissions is no longer optional—it’s a necessity. With increasing global awareness about climate change and air pollution, emission control systems have become vital parts",
  },
  {
    img: NewsImg20,
    slug: "how-medium-frequency-power-switching-transforming-industry",
    title: "How Is Medium-Frequency Power Switching Transforming Industry?",
    date: "April 23, 2025",
    comments: "No Comments",
    excerpt: "Efficiency and precision are no longer optional in high-demanding industrial environments. One significant invention pushing this transformation is medium-frequency power switching. This technology changes how",
  },
  {
    img: NewsImg21,
    slug: "how-to-select-right-smps",
    title: "How to Select the Right SMPS for Your Power Requirements?",
    date: "April 23, 2025",
    comments: "No Comments",
    excerpt: "SMPS stands for Switched-Mode Power Supply, a type of electronic power supply that uses switching regulators to efficiently convert electrical power. Unlike traditional linear power",
  },
   {
    img: NewsImg22,
    slug: "how-to-choose-transformer-bushing-high-voltage",
    title: "How to Choose the Right Transformer Bushing for High Voltage Applications?",
    date: "April 23, 2025",
    comments: "No Comments",
    excerpt: "In high-voltage systems like Electrostatic Precipitators (ESPs), every part counts—particularly Transformer Bushings. These aren’t just mechanical insulators but crucial links that assure safe and efficient",
  },
  {
    img: NewsImg23,
    slug: "understanding-transformer-bushings-types-functions",
    title: "Understanding Transformer Bushings: Types, Functions, and Importance",
    date: "March 5, 2025",
    comments: "No Comments",
    excerpt: "Understanding Transformer Bushings Transformer bushings are critical components designed to safely guide electrical conductors through a grounded transformer casing, providing both mechanical support and electrical",
  },
  {
    img: NewsImg24,
    slug: "esp-thermal-power-plants-efficiency",
    title: "The Role of Electrostatic Precipitators in Thermal Power Plants: How They Improve Efficiency",
    date: "March 5, 2025",
    comments: "No Comments",
    excerpt: "The high quantities of electricity produced by thermal power plants also generate impurities in fine particles, soot, and fly ash. To the rescue comes electrostatic",
  },
  {
    img: NewsImg25,
    slug: "adorpowertron-smps-cuts-energy-consumption",
    title: "How Adorpowertron’s SMPS Cuts Energy Consumption across Industries?",
    date: "March 5, 2025",
    comments: "No Comments",
    excerpt: "Industries continually aspire to energy-efficient solutions to decrease power consumption and lower operational expenses. One such creation is SMPS Power (Switch Mode Power Supply). It",
  },
  {
    img: NewsImg26,
    slug: "smps-vs-traditional-power-supplies",
    title: "SMPS vs. Traditional Power Supplies: A Comprehensive Comparison",
    date: "January 24, 2025",
    comments: "No Comments",
    excerpt: "Substantial improvements have occurred over the years, with the Switch-Mode Power Supply (SMPS) appearing as a chosen solution across diverse enterprises. But how are they",
  },
   {
    img: NewsImg27,
    slug: "how-switch-mode-power-supply-improves-energy-efficiency",
    title: "How Switch Mode Power Supply Improves Energy Efficiency in Devices?",
    date: "January 24, 2025",
    comments: "No Comments",
    excerpt: "Looking to power your devices smarter, not harder? That’s where Switch Mode Power Supplies (SMPS) come in—delivering high efficiency without the bulk or heat of",
  },
   {
    img: NewsImg28,
    slug: "emission-control-systems-industrial-challenges-solutions",
    title: "Emission Control Systems for Industrial Applications: Challenges and Solutions",
    date: "January 24, 2025",
    comments: "No Comments",
    excerpt: "As industries aspire to fulfill rising energy needs and environmental regulations, controlling emissions has become crucial. An emission control system is essential for reducing pollutants released",
  },
  {
    img: NewsImg29,
    slug: "how-esp-improve-air-quality-industrial-settings",
    title: "How Electrostatic Precipitators Improve Air Quality in Industrial Settings?",
    date: "January 24, 2025",
    comments: "No Comments",
    excerpt: "The power generation, cement, steel, and pulp and paper industries are among the top sectors donating to a country’s financial growth and development. Nevertheless, they",
  },
  {
    img: NewsImg30,
    slug: "role-transformer-bushings-safe-power-transmission",
    title: "The Role of Transformer Bushings in Ensuring Safe Power Transmission",
    date: "January 24, 2025",
    comments: "No Comments",
    excerpt: "When thinking about power transmission, one probably thinks about massive transformers, high-voltage lines, and systems of intricate intricacies that work together in harmony to deliver",
  },
  {
    img: NewsImg31,
    slug: "upgrading-transformer-rectifier-systems",
    title: "Why Upgrading Your ESP’s Transformer Rectifier System Makes Business Sense",
    date: "January 24, 2025",
    comments: "No Comments",
    excerpt: "In the power, cement and steel industries, attaining optimal performance while satisfying strict environmental measures is a continuous challenge. A critical part of the electrostatic",
  },
   {
    img: NewsImg32,
    slug: "5-signs-you-need-to-replace-your-esp-mechanical-spares/",
    title: "5-signs-you-need-to-replace-your-esp-mechanical-spares/",
    date: "November 16, 2024",
    comments: "No Comments",
    excerpt: "Electrostatic Precipitators (ESPs) are essential for controlling particulate emissions in industrial operations, but like any mechanical system, they require regular upkeep to maintain their efficiency.",
  },
   {
    img: NewsImg33,
    slug: "environmental-benefits-emission-control",
    title: "The Environmental Benefits of Upgrading Your Emission Control System",
    date: "November 15, 2024",
    comments: "No Comments",
    excerpt: "As industrial operations grow, minimizing emissions has become a priority for environmental and regulatory reasons. Upgrading your emission control system helps your facility comply with",
  },
  {
    img: NewsImg34,
    slug: "understanding-esp-components",
    title: "Understanding ESP Components: What Parts Make the System Work?",
    date: "November 15, 2024",
    comments: "No Comments",
    excerpt: "Understanding Esp Spares and Services ESP spares and services refer to the essential replacement parts and maintenance solutions that ensure the smooth and efficient operation",
  },
  {
    img: NewsImg35,
    slug: "igbt-technology-esp",
    title: "Improving Particulate Collection Efficiency in Electrostatic Precipitators in Coal-Fired Power Plants with Advanced IGBT Technology",
    date: "October 4, 2024",
    comments: "No Comments",
    excerpt: "Coal-fired power plants encounter strict environmental laws, particularly when handling particulate emissions. Electrostatic precipitators (ESPs) are crucial in catching fine particles from flue gases, guaranteeing",
  },
   {
    img: NewsImg36,
    slug: "transformer-rectifiers-coal-power",
    title: "The Role of Transformer Rectifiers in Enhancing Efficiency and Reducing Emissions in Coal-Fired Power Plants",
    date: "October 4, 2024",
    comments: "No Comments",
    excerpt: "Given the recent environmental attention, coal-fired power plants are being used to improve efficiency and decrease ecological emissions. One pivotal technology is the transformer rectifier,",
  },
  {
    img: NewsImg37,
    slug: "switch-mode-power-supply-esp",
    title: "Switch Mode Power Supply in Emission Control Systems: A Key Component for Electrostatic Precipitators in Coal-Fired Power Plants",
    date: "October 4, 2024",
    comments: "No Comments",
    excerpt: "Emission control is crucial for decreasing air pollution, significantly reducing harmful pollutants released into the atmosphere. It also complies with environmental regulations for coal-fired power",
  },
   {
    img: NewsImg38,
    slug: "maximizing-efficiency-esp-coal",
    title: "Maximizing Efficiency: Best Practices for Maintaining Electrostatic Precipitators in Coal Power Plants",
    date: "October 4, 2024",
    comments: "No Comments",
    excerpt: "Electrostatic precipitators (ESPs) are essential in decreasing air pollution from coal power plants. As one of the most practical technologies for catching particulate matter from",
  },
  {
    img: NewsImg39,
    slug: "transformer-bushings-coal-power",
    title: "How Transformer Bushings Impact Power Plant Efficiency and Safety: A Focus on Coal-Fired Power Plants",
    date: "October 4, 2024",
    comments: "No Comments",
    excerpt: "In coal-fired power plants, transformer bushings are crucial components that ensure safe and efficient electrical transmission. They provide electrical insulation where conductors pass through ground",
  },
  {
    img: NewsImg40,
    slug: "designing-efficient-smps-coal",
    title: "Designing Efficient SMPS for Coal-Fired Power Plants: Key Considerations and Common Applications",
    date: "October 4, 2024",
    comments: "No Comments",
    excerpt: "Ensuring effective emission control and operational efficiency is paramount in coal-fired power plants. Switch-mode Power Supplies (SMPS) play a pivotal role in achieving these objectives.",
  },
   {
    img: NewsImg41,
    slug: "acusensus-traffic-technology",
    title: "Acusensus featured in cover story of the latest issue of Traffic Technology International",
    date: "March 26, 2024",
    comments: "No Comments",
    excerpt: "Detecting drivers who are using phones at the wheel has long been a labor intensive manual task. But now the worlds first automated solutions are",
  },
   {
    img: NewsImg42,
    slug: "motorists-mobile-phone-driving",
    title: "Motorists’ mobile phone use is today’s ‘drink-driving’, authorities say",
    date: "March 26, 2024 ",
    comments: "No Comments",
    excerpt: "“If you’re travelling at 100km/h an hour, for 55 metres it’s equivalent to having a blindfold on.”",
  },
  {
    img: NewsImg43,
    slug: "acusensus-texting-driving",
    title: "Soon drivers in Australia won’t be able to get away with texting and driving, thanks to Acusensus technology.",
    date: "March 26, 2024 ",
    comments: "No Comments",
    excerpt: "Ador recently announced an investment in Australian traffic and safety enforcement specialist Acusensus Pty Ltd, taking a majority equity position in the company.",
  },
   {
    img: NewsImg44,
    slug: "ador-equity-traffic-safety",
    title: "Ador makes a 51% equity investment in pioneering Australian Traffic Safety company",
    date: "March 26, 2024 ",
    comments: "No Comments",
    excerpt: "The only one way to counter the increasing traffic fatalities around the world is to use intelligent technology",
  },
  


];


const ITEMS_PER_PAGE = 5;
const TOTAL_PAGES = Math.ceil(newsItems.length / ITEMS_PER_PAGE);

export default function NewsPage() {
  const [currentPage, setCurrentPage] = useState(1);

  const paginatedItems = newsItems.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const getPageNumbers = () => {
    if (TOTAL_PAGES <= 7) return Array.from({ length: TOTAL_PAGES }, (_, i) => i + 1);

    if (currentPage <= 3) {
      return [1, 2, 3, "...", 7, 8, 9];
    } else if (currentPage >= TOTAL_PAGES - 2) {
      return [1, "...", 7, 8, 9];
    } else {
      return [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", TOTAL_PAGES];
    }
  };

  return (
    <div className="nw">
      <style>{CSS}</style>

      {/* ══ 1. HERO ══ */}
      <section className="nw-hero">
        <img className="nw-hero-bg" src={HeroBgImg} alt="News Hero" />
        <div className="nw-hero-overlay" />
        <div className="nw-hero-content">
          <h1 className="nw-hero-title">News</h1>
          <hr className="nw-hero-divider" />
        </div>
      </section>

      {/* ══ 2. BREADCRUMB ══ */}
      <nav className="nw-breadcrumb" aria-label="Breadcrumb">
        <div className="nw-breadcrumb-inner">
          <a href="/" className="nw-bc-item">Home</a>
          <span className="nw-bc-sep"><img src={BcSepIcon}></img></span>
          <span className="nw-bc-item active">News &amp; Updates</span>
        </div>
      </nav>

      {/* ══ 3. MAIN CONTENT ══ */}
      <section className="nw-main-section">
        <div className="nw-inner">
          <div className="nw-main-row">

            
  {/* ── News List ── */}
            <div className="nw-list">
              {paginatedItems.map((item, idx) => (
                <div className="nw-item" key={idx}>
                  <img className="nw-item-img" src={item.img} alt={item.title} />
                  <div className="nw-item-body">
                    <a href={`/news/${item.slug}`} className="nw-item-title">{item.title}</a>
                    <p className="nw-item-meta">{item.date} &nbsp;|&nbsp; {item.comments}</p>
                    <p className="nw-item-excerpt">{item.excerpt}</p>
                    <a href={`/news/${item.slug}`} className="nw-read-more">
                      Read More
                      <img src={ReadMoreArrow} alt="arrow" className="nw-read-more-arrow" />
                    </a>
                  </div>
                </div>
              ))}
 
              {/* ── Pagination ── */}
              <div className="nw-pagination">
                <button
                  className="nw-page-btn prev-next"
                  onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                  disabled={currentPage === 1}
                >
                  <img src={PrevArrowIcon} alt="Previous" className="nw-page-nav-icon" />
                  Previous
                </button>

                {getPageNumbers().map((page, idx) =>
                  page === "..." ? (
                    <span key={idx} className="nw-page-dots">...</span>
                  ) : (
                    <button
                      key={idx}
                      className={`nw-page-btn${currentPage === page ? " active" : ""}`}
                      onClick={() => setCurrentPage(page)}
                    >
                      {page}
                    </button>
                  )
                )}

                <button
                  className="nw-page-btn prev-next"
                  onClick={() => setCurrentPage(p => Math.min(TOTAL_PAGES, p + 1))}
                  disabled={currentPage === TOTAL_PAGES}
                >
                  Next
                  <img src={NextArrowIcon} alt="Next" className="nw-page-nav-icon" />
                </button>
              </div>
            </div>

            {/* ── Sidebar ── */}
            <div className="nw-sidebar">
              <p className="nw-sidebar-title">Social Media</p>
              <div className="nw-social-icons">
                <a href="#" className="nw-social-icon" aria-label="YouTube">
                  <img src={YoutubeIcon} alt="YouTube" />
                </a>
                <a href="#" className="nw-social-icon" aria-label="LinkedIn">
                  <img src={LinkedinIcon} alt="LinkedIn" />
                </a>
              </div>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
}